import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, TextField } from "@mui/material";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { InvestorData } from "../../templates/Investor";

interface Props {
  searched: string;
  initRows: InvestorData[];
  setRows: Dispatch<SetStateAction<InvestorData[]>>;
  setSearched: Dispatch<SetStateAction<string>>;
}

export default function SearchInvestorRows(props: Props) {
  const { searched, initRows, setRows, setSearched } = props;

  const requestSearch = (searchedVal: string) => {
    const filteredRows = initRows.filter((row) =>
      // nameキーのみ、部分一致で検索
      row.name.toLowerCase().includes(searchedVal.toLowerCase())
    );
    setRows(filteredRows);
  };

  const changeSearchedHandler = (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setSearched(event.target.value);
    requestSearch(event.target.value);
  };

  return (
    <div>
      <TextField
        variant="standard"
        label="Name"
        value={searched}
        onChange={(event) => changeSearchedHandler(event)}
        autoComplete="off"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
}
